import React from 'react'

/**
 * 提示框
 */
export default class Warning extends React.Component {
  render(){
    if (!this.props.warn) {
      return null
    }

    let warn = "warning"
    return (
      <div className={`alert alert-${warn}`} role="alert">
        {this.props.warn}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./usr/lib/ui/src/components/bootstrap/Warning.js